export var ThunderboltPreviewParts;
(function (ThunderboltPreviewParts) {
    ThunderboltPreviewParts["Mapper"] = "mapper";
    ThunderboltPreviewParts["Component"] = "component";
    ThunderboltPreviewParts["Controller"] = "controller";
    ThunderboltPreviewParts["PreviewMapper"] = "previewMapper";
    ThunderboltPreviewParts["PreviewWrapper"] = "previewWrapper";
})(ThunderboltPreviewParts || (ThunderboltPreviewParts = {}));
export const findByPartName = (entries, part) => entries.find(entry => entry.part === part);
//# sourceMappingURL=helpers.js.map